import { CheckSquare, Square } from 'lucide-react';

export function ConsentSection({ title, children }) {
  return (
    <div className="bg-white/5 rounded-xl p-5">
      <p className="font-medium text-white/80 mb-2">{title}</p>
      <p className="text-sm text-white/60 leading-relaxed">{children}</p>
    </div>
  );
}

export function CheckItem({ checked, onToggle, label, testId }) {
  return (
    <button data-testid={testId} onClick={onToggle} className="flex items-start gap-3 text-left w-full group py-2">
      {checked
        ? <CheckSquare className="w-5 h-5 text-cyan-400 mt-0.5 shrink-0" />
        : <Square className="w-5 h-5 text-white/30 mt-0.5 shrink-0 group-hover:text-white/60" />
      }
      <span className={`text-sm ${checked ? 'text-white/90' : 'text-white/60'}`}>{label}</span>
    </button>
  );
}
